import Loader from "./Loader.molecule";

export default Loader;
